import { setupAPIServer } from '@services/api-server'

export const api = setupAPIServer()
